import { actionGenerator } from '../../redux/actionGenerator';
import { EFormKeyActionType } from './types';

/**
 * Action служит для генерации нового уникального ключа для формы.
 * Вызывать его только тогда, когда требуется сброс формы на первоначальный шаг.
 * При этом сохраняются values которые лежат в форме.
 */
export var generateFormKey = actionGenerator(EFormKeyActionType.Generated);